<template>
    <div>
        <v-tabs color="primary">
            <v-tabs-slider color="primary"></v-tabs-slider>
            <v-tab href="#js">JavaScript</v-tab>
            <v-tab href="#cs">C#</v-tab>
            <v-tab href="#py">Python</v-tab>
            <v-tab href="#php">PHP</v-tab>

            <v-tab-item value="js" class="mt-5">
                <syntaxer lang="js" :text="code.js" />
            </v-tab-item>

            <v-tab-item value="cs" class="mt-5">
                <syntaxer lang="csharp" :text="code.cs" />
            </v-tab-item>

            <v-tab-item value="py" class="mt-5">
                <syntaxer lang="py" :text="code.py" />
            </v-tab-item>

            <v-tab-item value="php" class="mt-5">
                <syntaxer lang="php" :text="code.php" />
            </v-tab-item>
        </v-tabs>
    </div>
</template>

<script>
import ProductMixin from "@/mixins/Product";
import Syntaxer from "@/components/common/Syntaxer";
import store from "@/services/store";

import JsCode from "raw-loader!@/assets/plain/linkedin.js.txt";
import CSharpCode from "raw-loader!@/assets/plain/linkedin.cs.txt";
import PythonCode from "raw-loader!@/assets/plain/linkedin.py.txt";
import PhpCode from "raw-loader!@/assets/plain/linkedin.php.txt";

export default {
    props: ["id"],
    data: () => ({
        code: null
    }),
    components: { Syntaxer },
    mixins: [ProductMixin],
    created() {
        this.code = {
            js: this.format(JsCode),
            cs: this.format(CSharpCode),
            py: this.format(PythonCode),
            php: this.format(PhpCode)
        }
    },
    methods: {
        format(code) {
            code = code.replace(/%APIKEY%/g, store.state.id.apiKey);
            code = code.replace(/%PRODUCTID%/g, this.id);
            code = code.replace(/%APIURL%/g, "https://api.shadow-metrics.com/products/data/action");

            return code;
        }
    }
}
</script>